<template>
  <div class="flex justify-start sm:justify-between flex-wrap gap-[8px] flex-col sm:flex-row">
    <div class="flex items-center flex-wrap gap-[8px] sm:flex-1">
      <nested-dropdown
        ref="filterDropdown"
        size="sm"
        toggle-class="text-decoration-none toggle-custom button-primary rounded-lg py-[7px] px-1"
      >
        <template #toggle>
          <i class="k-filter-search text-[24px]" />
        </template>
        <template #header>
          <div class="p-[16px] pt-[9px] border-b-[1px] border-[#E2E2E2] text-[#000000] font-semibold">
            Filter
          </div>
        </template>
        <nested-dropdown-submenu
          v-for="filter in filterOptions"
          :key="filter.label"
          ref="categorySubmenu"
          :label="filter.label"
          menu-class="!min-w-[200px] !py-0"
          :toggle-class="`!rounded-none text-left !text-[#000000] !font-medium !px-[16px] !py-[12px]${sortBy.key === filter.value ? ' !bg-[#FCD4BE]' : ''}`"
        >
          <b-dropdown-item
            v-for="options in filter.options"
            :key="options.value"
            :class="{ '!bg-[#FCD4BE] [&>a]:!text-[#F95031]': sortBy.key === filter.value && sortBy.type === options.value }"
            @click="handleSortChange(filter.value, options.value)"
          >
            {{ options.label }}
          </b-dropdown-item>
        </nested-dropdown-submenu>
        <b-button
          variant="ghost"
          size="sm"
          class="!text-[#E31A1A] !font-normal text-[12px] !px-[16px] !py-[7px] -mb-[7px] !rounded-none !rounded-b-[4px] !w-full !border-none text-left hover:bg-[#FCD4BE]"
          @click="resetAll"
        >
          Reset Filter
        </b-button>
      </nested-dropdown>
      <div
        class="flex items-center rounded-[8px] h-[43.5px] overflow-hidden !border border-[#e2e2e2] has-[:focus]:border-[#f95031] w-full max-w-[320px]"
      >
        <i
          class="k-search-normal-1 ml-[12px] text-[24px] cursor-pointer"
          @click="$refs.search.focus()"
        />
        <b-form-input
          ref="search"
          v-model="keyword"
          type="search"
          placeholder="Cari nama, email atau no HP"
          class="border-0 shadow-none !text-[14px]"
          size="lg"
          :debounce="DEBOUNCED_CHANGE_TIMEOUT"
          @change="triggerFilterChange"
        />
      </div>
    </div>
    <div>
      <b-button
        variant="primary"
        class="!flex self-start sm:self-auto items-center justify-center gap-[14px] !px-[14px] !py-[8px]"
        @click="handleCreateCampaign"
      >
        <span class="k-add !text-[20px] font-semibold" />
        Buat Campaign
      </b-button>
    </div>
  </div>
</template>

<script>
import { NestedDropdown, NestedDropdownSubmenu } from '@core/components/nested-dropdown'
import { CAMPAIGN_LIST_FILTER_OPTIONS } from '../config'

export default {
  name: 'FilterComponent',
  components: {
    NestedDropdown,
    NestedDropdownSubmenu,
  },
  data() {
    const { keyword, sort_key, sort_type } = this.$route.query
    return {
      sortBy: {
        key: sort_key,
        type: sort_type,
      },
      keyword,
    }
  },
  computed: {
    filterOptions() {
      return CAMPAIGN_LIST_FILTER_OPTIONS
    },
    generateQueryParam() {
      const { keyword, sortBy } = this
      const query = {}
      if (keyword) query.keyword = keyword
      if (sortBy.key) query.sort_key = sortBy.key
      if (sortBy.type) query.sort_type = sortBy.type
      return query
    },
  },
  watch: {
    keyword: {
      handler(newValue) {
        this.triggerFilterChange()
      },
    },
  },
  created() {
    this.DEBOUNCED_CHANGE_TIMEOUT = 500
  },
  beforeDestroy() {
    if (this.debouncedCategoryChange) {
      this.debouncedCategoryChange.cancel()
    }
  },
  methods: {
    handleSortChange(key, type) {
      this.sortBy = { key, type }
      this.triggerFilterChange()
      this.$refs.filterDropdown.close()
    },
    emitChange() {
      this.$emit('change', {
        keyword: this.keyword,
        sortBy: this.sortBy,
      })
    },
    updateQueryParam() {
      const {
        keyword, sort_key, sort_type, ...restQuery
      } = this.$route.query
      const query = { ...restQuery, ...this.generateQueryParam }

      if (_.isEqual(query, this.$route.query)) return
      this.$router.replace({ query }).catch(() => { })
    },
    triggerFilterChange() {
      this.updateQueryParam()
      this.emitChange()
    },
    resetAll() {
      this.sortBy = {
        key: undefined,
        type: undefined,
      }
      this.triggerFilterChange()
      this.$refs.filterDropdown.close()
    },
    handleCreateCampaign() {
      this.$router.push({
        name: 'create-campaign-komlabs',
      })
    },
  },
}
</script>
